import { useHotkeyHints } from '../../context/HotkeyContext';

interface HotkeyHintProps {
  hotkey: string;
  className?: string;
}

export function HotkeyHint({ hotkey, className = '' }: HotkeyHintProps) {
  const showHotkeys = useHotkeyHints();

  return (
    <kbd className={`
      ml-2 hidden sm:inline-flex items-center rounded
      px-1.5 text-[10px] font-medium select-none
      transition-all duration-150
      ${showHotkeys
        ? 'opacity-100 bg-indigo-50 text-indigo-500 border border-indigo-200'
        : 'opacity-0 border border-gray-200 text-gray-400'}
      ${className}
    `}>
      ⌃{hotkey.toUpperCase()}
    </kbd>
  );
}
